import { render, staticRenderFns } from "./TermsSection.vue?vue&type=template&id=28ef267b&"
import script from "./TermsSection.vue?vue&type=script&lang=js&"
export * from "./TermsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports